import React from 'react';
import ABDetailPage from '../pages/detail/ABDetailPage';

const ABDetailProvider = (props: any) => {
    const { params } = props.match;
    return (
        <React.Fragment>
            <ABDetailPage testId={params?.id} />
        </React.Fragment>
    );
}

export default ABDetailProvider;